module.exports = __webpack_public_path__ + "static/media/f_hairstyle_curly_long_front_shadow.597525a2.png";